import {
  RETRIEVE_ALL_UPLOADED_FILES_FOR_TOPIC_BEGIN,
  RETRIEVE_ALL_UPLOADED_FILES_FOR_TOPIC_SUCCESS,
  RETRIEVE_ALL_UPLOADED_FILES_FOR_TOPIC_FAILURE
} from './constants';
import http from '../../../common/http';
import { apiEndPoints } from '../../../common/globalConstants';

export function retrieveAllUploadedFilesForTopic(props) {
  return dispatch => {
    dispatch({
      type: RETRIEVE_ALL_UPLOADED_FILES_FOR_TOPIC_BEGIN,
    });
    const url = `${apiEndPoints.uploadedFiles.UPLOADED_FILES}?topicId=${props.topicId}`;
    const promise = new Promise((resolve, reject) => {
      const doRequest = http.get(url);
      doRequest.then(
        res => {
          dispatch({
            type: RETRIEVE_ALL_UPLOADED_FILES_FOR_TOPIC_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        err => {
          dispatch({
            type: RETRIEVE_ALL_UPLOADED_FILES_FOR_TOPIC_FAILURE,
          });
          reject(err);
        },
      );
    });
    return promise;
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case RETRIEVE_ALL_UPLOADED_FILES_FOR_TOPIC_BEGIN:
      return {
        ...state,
        retrieveAllUploadedFilesForTopicBegin: true,
        retrieveAllUploadedFilesForTopicFailure: false,
        retrieveAllUploadedFilesForTopicSuccess: false,
        allUploadedFilesForTopic: {}
      };
    case RETRIEVE_ALL_UPLOADED_FILES_FOR_TOPIC_SUCCESS:
      return {
        ...state,
        retrieveAllUploadedFilesForTopicBegin: false,
        retrieveAllUploadedFilesForTopicSuccess: true,
        allUploadedFilesForTopic: action.data,
      };
    case RETRIEVE_ALL_UPLOADED_FILES_FOR_TOPIC_FAILURE:
      return {
        ...state,
        retrieveAllUploadedFilesForTopicBegin: false,
        retrieveAllUploadedFilesForTopicFailure: true
      };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/features/topics/redux/retrieveAllUploadedFilesForTopic.js